import { Component, Inject,   OnInit } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Item } from '../../item-detail.service';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MatIconModule } from '@angular/material/icon';

export interface ILightBox {
  product?: Item;
  images?: Set<string>;
}


export interface IIMg {
  img: string
}
@Component({
  selector: 'app-popup-lightbox',
  standalone: true,
  imports: [MatDialogModule, CommonModule, CarouselModule,MatIconModule],
  templateUrl: './popup-lightbox.component.html',
  styleUrl: './popup-lightbox.component.scss',
  providers: [
    { provide: MatDialogRef, useValue: {} },

    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } }
  ]
})
export class PopupLightboxComponent implements OnInit {

  product?: Item;
  images = new Set<string>();
  slideConfig = { "slidesToShow": 1, "slidesToScroll": 1 };
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    merge: false,
    autoHeight: false,
    autoWidth: false,
    center:true,
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 1
      },
      940: {
        items: 1
      },
      1000:{
        items:1
      }
    },
    nav: false,

  }
  constructor(@Inject(DIALOG_DATA) public data: ILightBox,
    private dialogRef: DialogRef<PopupLightboxComponent>

  ) {
    this.product = data.product
    this.images = data.images!
  }
  ngOnInit(): void {

  }
  getArr(): IIMg[] {
    const ff: IIMg[] = [];
    Array.from(this.images).forEach(w => {
      ff.push({
        img: w
      });
    })
    return ff;
  }

   close(){
    this.dialogRef.close()
   }
}
